/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Account Info General Group component
 *
 * @author Yakov Gushchin
 * @version 1.16.1
 * @since 1.11.0
 */

import { useMemo } from 'react';

import { EllipseText, TextBlock } from '../../../components/common';
import { AccountInfoGeneralInfoGroupStyled } from './styled/AccountInfoGeneralStyled';

interface IAccountInfoGeneralGroup {
    noFieldValue?: string;
    noEllipse?: boolean;
    title: string;
    value?: string | number;
}

const AccountInfoGeneralGroup = (props: IAccountInfoGeneralGroup) => {
    const value = useMemo(() => props.value || props.noFieldValue, [props.value, props.noFieldValue]);

    return (
        <AccountInfoGeneralInfoGroupStyled>
            <TextBlock className="account-info-general__title">{props.title}</TextBlock>
            {props.noEllipse ? <TextBlock>{value}</TextBlock> : <EllipseText title={value}>{value}</EllipseText>}
        </AccountInfoGeneralInfoGroupStyled>
    );
};

export default AccountInfoGeneralGroup;
